import { render, staticRenderFns } from "./CertificateCopy.vue?vue&type=template&id=228a233f&"
import script from "./CertificateCopy.vue?vue&type=script&lang=js&"
export * from "./CertificateCopy.vue?vue&type=script&lang=js&"
import style0 from "./CertificateCopy.vue?vue&type=style&index=0&id=228a233f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports